import { browser } from '@src/slide/infrastructure/module/independent/agent/common';

export function getArraySum(arr): number {
    return arr.reduce((pre, cur) => Number(pre) + Number(cur), 0);
}

export function isEnableBoxDevLine(): boolean {
    return /box=1/.test(location.search);
}

export function isEmptyValue(value): boolean {
    return value === '' || value === undefined || value === null || isNaN(value);
}

/**
 * 获取屏幕像素比
 */
export function getPixelRatio() {
    const pixelRatio = window ? window.devicePixelRatio : 1;
    // 不足 1 的取 1，超出 1 的取整
    return pixelRatio >= 1 ? Math.ceil(pixelRatio) : 1;
}

export const addSyncTask = (task: () => any) => new Promise((resolve) => {
    setTimeout(() => {
        resolve(task());
    }, 50);
});


export const lowMemoryMode = browser.isMobile;
